import { Checkbox, Space } from 'antd';
import { map } from 'lodash';
import React from 'react';
import { Stack } from 'components/stack/stack';
import { Text } from 'components/text/Text';
import { GroupSize, OfferResponse } from 'logic/api-models/api-models';
import { isTutoringTypeEnabled } from 'logic/api-models/tutoring-type.logic';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { isString } from 'logic/utils/string';
import './TutorClassLocation.less';

export const SchoolOfferGroup: React.FC<{
  offer: OfferResponse | undefined;
}> = ({ offer }) => {
  return (
    <div>
      <Stack gap={0.5} flow="row">
        <Text color="primary" size={14} strong>
          {translate(translationKeys.offerDetails.groupTypes)}
        </Text>
        {map(GroupSize).map((groupSize) => {
          if (isString(groupSize)) {
            const isChecked = isTutoringTypeEnabled(offer?.tutoringSchool?.groupSizes, groupSize);
            return (
              <Space key={groupSize} direction={'horizontal'}>
                <Checkbox className="teaching-location" checked={isChecked} disabled>
                  {translate(translationKeys.common.groupSize[groupSize])}
                </Checkbox>
              </Space>
            );
          }
        })}
      </Stack>
    </div>
  );
};
